var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full"},[(_vm.variant)?_c('spinner-wheel-table',{attrs:{"variant":_vm.variant}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }